import { cn } from '@/lib/utils';

interface TagBadgeProps {
  name: string;
  color: string;
  size?: 'sm' | 'md';
  onClick?: () => void;
  onRemove?: () => void;
  className?: string;
}

export function TagBadge({ 
  name, 
  color, 
  size = 'sm', 
  onClick,
  onRemove,
  className 
}: TagBadgeProps) {
  return (
    <span
      onClick={onClick}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full font-medium transition-all",
        size === 'sm' ? "px-2.5 py-1 text-xs" : "px-3 py-1.5 text-sm",
        onClick && "cursor-pointer hover:opacity-80",
        className
      )}
      style={{
        backgroundColor: `${color}20`,
        color: color,
        border: `1px solid ${color}40`,
      }}
    >
      <span 
        className={cn(
          "rounded-full",
          size === 'sm' ? "w-2 h-2" : "w-2.5 h-2.5"
        )}
        style={{ backgroundColor: color }}
      />
      {name}
      {onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="ml-0.5 hover:opacity-60"
        >
          ×
        </button>
      )}
    </span>
  );
}
